export const isIOS = () => {
	if (typeof window === 'undefined') return false
	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	)
}
